export const AppVersion = "1.1.0";
